<template>
  <div class="container">
    <div class="flex">
      <p class="container__time-send">
        Invitación enviada el {{ formatDate(userAccount?.updated_at) }}
      </p>
      <a-divider class="container__divider" />
      <a-form class="form" ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item class="form__item" label="Correo electrónico" name="email">
              <a-input
                v-model:value="formState.email"
                placeholder="Escribir correo electrónico"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item class="form__item" label="Tipo de perfil asignado">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.profile"
              >
                <a-select-option v-for="profile in profiles" :key="profile.id">{{
                  profile.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="drawing">
        <img
          class="container__picture"
          src="@/app/users/assets/profiles/resend-email.png"
          alt="email"
        />
        <p>Se ha enviado una invitación por correo electrónico a este usuario.</p>
        <span>Para aparecer activo debe aceptar la invitación. </span>
        <div class="separator"></div>
        <div v-if="counter === 0 || counter === 50">
          <p>¿Deseas enviar nuevamente otra invitación a "{{ formState.email }}"</p>
          <a @click="sendMessage">Haz click aquí</a>
          <br />
        </div>
        <div v-if="counter <= 49">
          <p>Se ha enviado una nueva invitación</p>
          <span style="margin-right: 5px">Podras enviar otra invitación en</span>
          <span><span v-if="counter > 10">00:</span>{{ counter }} seg</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div v-if="update" class="control__user">
        <a-button v-if="!record.is_owner" type="link" class="button" @click="handleDeleteUser">
          <span class="deleteUser">Eliminar invitación</span>
        </a-button>
      </div>
      <div class="container__footer">
        <a-button class="footer__back" @click="handleCancel"> Cancelar </a-button>
        <a-button
          class="footer__next"
          type="primary"
          @click="handleOk"
          :disabled="isDisabled"
          :loading="loading"
        >
          Actualizar información
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { humanDateTimeWithSlashFormat } from "@/app/shared/utils/constants";
import { dateToString, hourToLocalTime } from "@/app/shared/utils/dates";
import { registerEventManagement } from "@/app/shared/services";
import { EventManagement, UserStatus, StateOptions } from "@/app/shared/utils/enums";
import { useStore } from "vuex";
import { message, Modal } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { fetchUserById } from "@/app/users/services";
import { defineComponent, reactive, ref, computed, createVNode } from "vue";
import moment from "moment-timezone";
import { safeRegisterEventManagement } from "@/app/shared/composables/useRegisterEventManagement";

export default defineComponent({
  name: "ResendEmailModal",
  props: {
    record: {
      type: Object,
      default: null,
    },
    update: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const counter = ref(50);
    const loading = ref(false);
    const secondMessage = ref(true);
    const buttonDisabled = ref(false);
    const hidenNumber = ref(false);
    let formState;
    if (props.update) {
      formState = reactive({
        email: props.record.email,
        profile: props.record.profile,
      });
    }
    const handleOk = () => {
      formRef.value.validateFields().then(async () => {
        try {
          const body = {
            email: formState.email,
            profile: formState.profile,
          };
          loading.value = true;
          await store.dispatch("updateInvitationUser", {
            id: props.record.id,
            data: body,
          });
          // store.dispatch("fetchAllUsers");
          context.emit("updateTable");
          context.emit("onCloseModal");
          loading.value = false;
          message.success("Se actualizó y se envió una nueva invitación correctamente");
        } catch (error) {
          loading.value = false;
          message.warning("Algo salió mal, por favor, vuelve a intentarlo");
        }
      });
    };
    const isDisabled = computed(() => {
      return (
        formState.email.valueOf() === props.record.email.valueOf() &&
        formState.profile.valueOf() === props.record.profile.valueOf()
      );
    });
    const rules = {
      email: [
        { type: "email", message: "Ingrese un correo válido" },
        { required: true, message: "Campo requerido", trigger: "blur" },
      ],
    };
    return {
      formRef,
      formState,
      rules,
      secondMessage,
      buttonDisabled,
      hidenNumber,
      handleOk,
      loading,
      counter,
      isDisabled,
    };
  },
  data() {
    return {
      dateBuf: true,
      UserStatus,
      userAccount: undefined,
      visibleTime: false,
      profilePicture: undefined,
      eventTime: undefined,
    };
  },

  computed: {
    profiles() {
      return this.$store.getters["getProfileList"];
    },
    usersInfo() {
      return this.$store.getters["getUserList"];
    },
    hourPlatform() {
      return this.$store.getters["getHourPlatform"];
    },
    formatTime() {
      return this.formatTimeHours(this.userAccount?.email_sent_at);
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  created() {
    this.$store.dispatch("fetchAllProfiles");
    this.fetchDataUSer();
  },
  methods: {
    async fetchDataUSer() {
      this.eventTime = await safeRegisterEventManagement(EventManagement.Online, {
        state: StateOptions.Connected,
        module: 'resend-email-modal',
      });
      this.fetchUserAccount();
    },
    sendTime() {
      const timer = setInterval(() => {
        this.counter = this.counter - 1;
        if (this.counter === 0) {
          clearInterval(timer);
          this.counter = 50;
        }
      }, 1000);
    },
    async fetchUserAccount() {
      this.userAccount = await fetchUserById(this.record.id);
      if (this.userAccount?.email_sent_at) {
        const fecha = new Date(this.userAccount?.email_sent_at);
        fecha.setSeconds(fecha.getSeconds() + 50);
        if (moment(fecha).isAfter(moment(this.eventTime?.start_hour))) {
          this.counter = moment(fecha).diff(moment(this.eventTime?.start_hour), "seconds");
          this.sendTime();
        }
      }
    },
    formatDate(date) {
      return dateToString(date, humanDateTimeWithSlashFormat);
    },
    formatTimeHours(date) {
      return hourToLocalTime(date, humanDateTimeWithSlashFormat);
    },
    sendMessage() {
      this.formRef.validateFields().then(async () => {
        try {
          const data = {
            email: this.formState.email,
          };
          this.fetchDataUSer();
          await this.$store.dispatch("resendEmailUser", data);
          this.secondMessage = false;
          this.$message.success("Se actualizó y se envió una nueva invitación correctamente.");
        } catch (error) {
          this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
        }
      });
    },
    localSendEmail(e) {
      const local = localStorage.setItem("counterEmail", this.counter);
      (e || window.event).returnValue = local; //Gecko + IE
      return local;
    },
    handleInput() {
      this.$emit("edit");
    },

    handleDeleteUser() {
      Modal.confirm({
        title: `¿Estás seguro de eliminar la invitación a “${this.formState.email}”?`,
        content:
          "Recuerda que este usuario ya no podrá unirse a tu equipo de trabajo. Si deseas volver a invitarlo, podrás hacerlo haciendo click en el botón de “Invitar usuarios”.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.deleteEmail(),
        centered: true,
        okText: "Eliminar",
        cancelText: "Cancelar",
      });
    },
    deleteEmail() {
      try {
        this.$store.dispatch("deleteUser", this.record.id);
        this.$emit("updateTable");
        this.$emit("onCloseModal");
      } catch (error) {
        this.$message.error("Error al eliminar el usuario");
      }
    },
    handleCancel() {
      this.localSendEmail();
      this.$emit("onCloseHideModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  margin-top: 4px

.button
  padding: 0

.flag
  width: 20px
  margin-bottom: 2px
.form
  overflow: hidden
  .title
    font-weight: 600
    font-size: 16px
    line-height: 24px
    color: $gray-9
p
  margin-bottom: 8px
.footer
  display: flex
  justify-content: space-between
  position: absolute
  padding: 0 16px
  left: 0
  width: 100%
  height: 56px
  bottom: 0
  background: $white
  align-items: center
  border-radius: 0px 0px 4px 4px

.disabledUser
  color: $gray-7

.deleteUser
  color: $red-6

:deep(.ant-calendar-picker)
  width: 188px
.state
  margin-right: 5px

.line-yellow
  height: 10px
  background: $yellow-6
  width: 350px
  border-radius: 5px
  margin-top: 40px

.drawing
  text-align: center
  font-size: 16px

.separator
  margin-bottom: 20px
  margin-top: 10px

.container
  &__footer
    display: flex
    gap: 8px
  &__time-send
    font-style: italic
    text-align: center
    margin-bottom: 0px
    font-size: 16px
    line-break: 24px
  &__divider
    margin: 16px 0px
  &__picture
    height: 122px
    margin: 30px auto 22px auto
</style>
